import * as yup from "yup";

export const CONDITIONAL_QUESTION_OPTIONS = {
  YES: "Yes",
  NO: "No",
  UNDECIDED: "Undecided",
};

export const addressValidationSchema = yup.object().shape({
  addressLine1: yup.string().required("Address is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  zipCode: yup
    .string()
    .matches(/(^\d{5}$)|(^\d{5}-\d{4}$)/, "Invalid zip code")
    .required("Zip code is required"),
});

export const clientValidationSchema = yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup.string().email("Invalid email address").required("Email is required"),
  phone: yup
    .string()
    .matches(/\+1[0-9]{10}$/, "Invalid phone number")
    .required("Phone number is required"),
});

export const US_STATES = [
  {
    title: "Alabama",
    value: "AL",
  },
  {
    title: "Alaska",
    value: "AK",
  },
  {
    title: "Arizona",
    value: "AZ",
  },
  {
    title: "Arkansas",
    value: "AR",
  },
  {
    title: "California",
    value: "CA",
  },
  {
    title: "Colorado",
    value: "CO",
  },
  {
    title: "Connecticut",
    value: "CT",
  },
  {
    title: "Delaware",
    value: "DE",
  },
  {
    title: "Florida",
    value: "FL",
  },
  {
    title: "Georgia",
    value: "GA",
  },
  {
    title: "Hawaii",
    value: "HI",
  },
  {
    title: "Idaho",
    value: "ID",
  },
  {
    title: "Illinois",
    value: "IL",
  },
  {
    title: "Indiana",
    value: "IN",
  },
  {
    title: "Iowa",
    value: "IA",
  },
  {
    title: "Kansas",
    value: "KS",
  },
  {
    title: "Kentucky",
    value: "KY",
  },
  {
    title: "Louisiana",
    value: "LA",
  },
  {
    title: "Maine",
    value: "ME",
  },
  {
    title: "Maryland",
    value: "MD",
  },
  {
    title: "Massachusetts",
    value: "MA",
  },
  {
    title: "Michigan",
    value: "MI",
  },
  {
    title: "Minnesota",
    value: "MN",
  },
  {
    title: "Mississippi",
    value: "MS",
  },
  {
    title: "Missouri",
    value: "MO",
  },
  {
    title: "Montana",
    value: "MT",
  },
  {
    title: "Nebraska",
    value: "NE",
  },
  {
    title: "Nevada",
    value: "NV",
  },
  {
    title: "New Hampshire",
    value: "NH",
  },
  {
    title: "New Jersey",
    value: "NJ",
  },
  {
    title: "New Mexico",
    value: "NM",
  },
  {
    title: "New York",
    value: "NY",
  },
  {
    title: "North Carolina",
    value: "NC",
  },
  {
    title: "North Dakota",
    value: "ND",
  },
  {
    title: "Ohio",
    value: "OH",
  },
  {
    title: "Oklahoma",
    value: "OK",
  },
  {
    title: "Oregon",
    value: "OR",
  },
  {
    title: "Pennsylvania",
    value: "PA",
  },
  {
    title: "Rhode Island",
    value: "RI",
  },
  {
    title: "South Carolina",
    value: "SC",
  },
  {
    title: "South Dakota",
    value: "SD",
  },
  {
    title: "Tennessee",
    value: "TN",
  },
  {
    title: "Texas",
    value: "TX",
  },
  {
    title: "Utah",
    value: "UT",
  },
  {
    title: "Vermont",
    value: "VT",
  },
  {
    title: "Virginia",
    value: "VA",
  },
  {
    title: "Washington",
    value: "WA",
  },
  {
    title: "West Virginia",
    value: "WV",
  },
  {
    title: "Wisconsin",
    value: "WI",
  },
  {
    title: "Wyoming",
    value: "WY",
  },
];

export const formatAddress = (address) => {
  if (!address?.addressLine1) return "";

  let textAddress = `${address.addressLine1}, ${address.city}, ${address.state} ${address.zipCode}`;

  return textAddress;
};

export const SELECT_MULTIPLE = [11];
export const CLIENT_DETAILS = [3];
export const ADDRESS_DETAILS = [2];
export const PENDING_STATUS = "pending";
export const REJECTED_STATUS = "rejected";
export const RESOLVED_STATUS = "resolved";
export const REDIRECT_STATUS = "redirect";
export const MIN_QUESTION = 3;

export const initialClientDetails = {
  addressLine1: "",
  firstName: "",
  lastName: "",
  email: "",
  address: "",
  city: "",
  state: "",
  zipCode: "",
  phone: "",
};

export const formatAddressForPlace = ({ geometry, ...place }) => {
  const addressComponents = place.address_components;
  let addressLine1 = "";
  let city = "";
  let state = "";
  let zipCode = "";
  let country = "";

  for (const component of addressComponents) {
    const componentType = component.types[0];
    switch (componentType) {
      case "street_number": {
        addressLine1 = `${component.long_name} ${addressLine1}`;
        break;
      }
      case "route": {
        addressLine1 += component.long_name;
        break;
      }
      case "postal_code": {
        zipCode = component.long_name;
        break;
      }
      case "locality": {
        city = component.long_name;
        break;
      }
      case "administrative_area_level_1": {
        state = component.short_name;
        break;
      }
      case "country":
        country = component.long_name;
        break;
      default:
        break;
    }
  }

  return {
    addressLine1,
    city,
    state,
    country,
    zipCode,
    longitude: geometry?.location?.lng(),
    latitude: geometry?.location?.lat(),
  };
};

export const QUIZ_QUESTION_FORMAT_SECTIONEDIT_FIELD_MAP = {
  options: "select",
  text: "text",
};

export const transformFormStateToQuizAnswerInput = (formState, projectId, userId) => {
  const finalAnswersInput = [];
  Object.keys(formState || {}).forEach((formKey) => {
    const formPropData = formState[formKey];
    const isOptionsQuestion = formPropData.question.questionFormat === "options";
    if ((isOptionsQuestion && formPropData.value?.opt?.id) || (!isOptionsQuestion && formPropData.value)) {
      finalAnswersInput.push({
        projectId,
        quizGroupQuestionId: formPropData.quizGroupQuestionId,
        questionFormat: formPropData.question.questionFormat,
        optionsAnswerId: isOptionsQuestion ? formPropData.value?.opt?.id : formPropData.value,
        userId,
      });
    }
  });
  return finalAnswersInput;
};

export const QUESTION_FORMAT_TO_QUIZ_ANSWER_MAP = {
  options: "optionsAnswer",
  text: "textAnswer",
  json: "jsonAnswer",
};

export const QUESTION_TYPES = {
  uploadPhoto: "uploadPhoto",
  conditional: "conditional",
  standard: "standard",
  intro: "intro",
  spaces: "spaces",
  address: "address",
  account: "account",
  images: "images",
  contactSlide: "contactSlide",
};

export const QUESTION_TYPE_SANITY_MAP = {
  quizQuestionBoolean: QUESTION_TYPES.standard,
  quizQuestionStandard: QUESTION_TYPES.standard,
  quizIntro: QUESTION_TYPES.intro,
  quizQuestionSpace: QUESTION_TYPES.spaces,
  quizQuestionImage: QUESTION_TYPES.images,
  quizQuestionAddress: QUESTION_TYPES.address,
  quizQuestionAccount: QUESTION_TYPES.account,
  quizQuestionContactSlide: QUESTION_TYPES.contactSlide,
};

export const transformSanityQuestion = (question) => {
  const questionTransformed = {
    ...question,
    sanityQuestion: question,
    title: question.questionTitle?.questionTitle,
    subtitle: question.questionTitle?.questionSubTitle,
    type: QUESTION_TYPE_SANITY_MAP[question._type],
    options: question.questionAnswers,
    questionFormat: question?.allowMultiAnswers ? "options" : "text",
    extraInfo: {
      enabled: question.questionTitle?.enabled || question.extrainfo?.enabled,
      icon: question.questionTitle?.icon || question.extrainfo?.icon,
      text: question.questionTitle?.text || question.extrainfo?.text,
    },
  };

  if (question._type === "quizQuestionSpace") {
    questionTransformed.showSkip = true;
    questionTransformed.skipText = "I’m not sure yet";
    questionTransformed.questionFormat = "spaces";
  }
  if (question._type === "quizQuestionImage") {
    questionTransformed.showSkip = true;
    questionTransformed.skipText = "I don't like these. Skip.";
    questionTransformed.questionFormat = "images";
  }
  if (question._type === "quizQuestionBoolean") {
    questionTransformed.options = [
      {
        _key: `${question._key}-yes`,
        primaryText: "Yes",
      },
      {
        _key: `${question._key}-no`,
        primaryText: "No",
      },
    ];
  }

  return questionTransformed;
};

export const capitalizeName = (str = "") => {
  return str
    .split(" ")
    .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
    .join(" ");
};

export const sliderSteps = (firstName) => [
  {
    id: 1,
    subtitle: "Welcome to the family",
    title: `Nice to meet you, ${firstName}. Let's make your dream come true.`,
    icon: "/icons/dream_house.svg",
  },
  {
    id: 2,
    subtitle: "Free consultation",
    title: "Speak with an expert for free. No pressure and no obligation.",
    icon: "/icons/relax.svg",
  },
  {
    id: 3,
    subtitle: "You're in good hands",
    title: "We've completed 2800+ projects for people like you.",
    icon: "/icons/blueprints.svg",
  },
];

const getSpaces = (spaces) => {
  let spaceIds = [];

  Object.keys(spaces || {}).forEach((key) => {
    if (!spaces[key]?.value) return;
    const newSpaces = Array(spaces[key].value)
      .fill(spaces[key])
      .map((space, index) => ({
        id: space.id,
        name: index === 0 ? space.name : `${space.name} ${index + 1}`,
      }));
    spaceIds = [...spaceIds, ...newSpaces];
  });

  return spaceIds;
};

export const getQuizBody = ({ questions, isHouzzLead, project }) => {
  let quizBody = [];
  let clientDetails = {};
  let projectDetails = {};
  const houzzLeadFields = isHouzzLead ? { projectId: project?.id } : {};
  let webhookURL = "";
  questions.forEach((questionItem) => {
    const projectType =
      questionItem.questionFormat === "text"
        ? questionItem?.questionAnswers
            ?.find((questionAnswer) => {
              return questionItem.answer?.[0] === questionAnswer.primaryText;
            })
            ?.metaTags?.find((tag) => tag?.name === "projectType")
        : null;

    if (projectType) {
      projectDetails.type = projectType.value;
    }

    if (questionItem.webhookURL) {
      webhookURL = questionItem.webhookURL;
    }

    if (questionItem.type === QUESTION_TYPES.standard) {
      quizBody = [
        ...quizBody,
        {
          sanityQuizQuestion: questionItem.sanityQuestion,
          questionFormat: questionItem.questionFormat,
          singleAnswer: questionItem.questionFormat === "text" ? questionItem.answer?.[0] : undefined,
          optionsAnswer: questionItem.questionFormat === "options" ? questionItem.answer : undefined,
          ...houzzLeadFields,
        },
      ];
    }

    if (questionItem.type === QUESTION_TYPES.spaces) {
      quizBody = [
        ...quizBody,
        {
          sanityQuizQuestion: questionItem.sanityQuestion,
          questionFormat: questionItem.questionFormat,
          jsonAnswer: getSpaces(questionItem.answer),
          ...houzzLeadFields,
        },
      ];
    }

    if (questionItem.type === QUESTION_TYPES.images) {
      quizBody = [
        ...quizBody,
        {
          sanityQuizQuestion: questionItem.sanityQuestion,
          questionFormat: questionItem.questionFormat,
          jsonAnswer: questionItem.answer?.map((image) => parseInt(image?.slice(6))), // remove "media_"
          ...houzzLeadFields,
        },
      ];
    }

    if (questionItem.type === QUESTION_TYPES.address) {
      projectDetails = {
        ...projectDetails,
        addressLine1: questionItem.answer.addressLine1,
        city: questionItem.answer.city,
        state: questionItem.answer.state,
        zipCode: questionItem.answer.zipCode,
        latitude: `${questionItem.answer.latitude || ""}`,
        longitude: `${questionItem.answer.longitude || ""}`,
      };
    }

    if (questionItem.type === QUESTION_TYPES.account) {
      const { finalPhoneNumber, ...rest } = questionItem.answer;
      clientDetails = {
        ...rest,
        phone: finalPhoneNumber.startsWith("+1") ? finalPhoneNumber.replace("+1", "") : finalPhoneNumber,
      };
    }
  });
  return { quizBody, clientDetails, projectDetails, webhookURL };
};

export const getAdjustedPosition = (currentPosition) => {
  return currentPosition === "3b" ? 3 : +currentPosition;
};
